import request from "@/utils/request";

export function getCaptcha() {
  return request({ url: "/captchaImage", method: "get" });
}

export function login(data) {
  return request({ url: "/login", method: "post", data });
}

export function getInfo() {
  return request({ url: "/getInfo", method: "get" });
}

/** 登录后发送手机号认证短信（防刷） */
export function sendBindSms(data) {
  return request({ url: "/auth/sms/send", method: "post", data });
}

/** 登录后短信认证绑定手机号 */
export function bindMobile(data) {
  return request({ url: "/auth/bindMobile", method: "post", data });
}

/** 微信扫码二维码参数 scene=login|bind */
export function wxQrConfig(params) {
  return request({
    url: "/auth/wx/qrConfig",
    method: "get",
    params,
    silentError: true,
  });
}

/** 微信扫码登录 */
export function wxLogin(data) {
  return request({ url: "/auth/wx/login", method: "post", data });
}

/** 登录后绑定微信 */
export function wxBind(data) {
  return request({ url: "/auth/wx/bind", method: "post", data });
}

export function logout() {
  return request({ url: "/logout", method: "post" });
}

/** 当前登录用户修改密码（RSA 密文，各角色通用） */
export function changePassword(data) {
  return request({ url: "/profile/password", method: "put", data });
}

export function dashboardStat() {
  return request({ url: "/monitor/dashboard", method: "get" });
}

/** 后台首页看板（数据概览、本学期、我的班级等） */
export function dashboardHome() {
  return request({ url: "/monitor/dashboard/home", method: "get" });
}

/** 管理端数据大屏（教学资源中心态势） */
export function situationScreen() {
  return request({ url: "/monitor/situation", method: "get" });
}
